let sequencia = 0;

export default {
  props: {
    show: { type: Boolean, default: false },
  },

  data() {
    sequencia += 1;

    return { nomeModal: `cashback-modal-${sequencia}` };
  },

  watch: {
    show(aberto) {
      this.alternarModal(aberto);
    },
  },

  mounted() {
    if (this.show) this.alternarModal(true);
  },

  methods: {
    alternarModal(aberto) {
      if (!aberto) {
        this.$modal.hide(this.nomeModal);

        return;
      }

      this.aoAbrir();
      this.$modal.show(this.nomeModal);
    },

    aoFecharModal() {
      if (this.show) this.$emit("update:show", false);
    },

    fechar() {
      if (!this.salvando) this.$emit("update:show", false);
    },
  },
};
